import React from 'react';
import { textareaPropTypes } from '@App/common/components/Textarea/TextareaPropTypes';
import TextareaCommon from '@App/common/components/Textarea/Textarea';
import FormErrorText from '@Theme/natucare/components/FormErrorText/FormErrorText';
import * as styles from './Textarea.module.scss';
const Textarea = props => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextareaCommon, Object.assign({}, props, {
  classname: `${styles.root} ${props.error ? styles.rootError : ''}`
})), (props === null || props === void 0 ? void 0 : props.error) && /*#__PURE__*/React.createElement(FormErrorText, {
  text: props.errorMsg
}));
export default Textarea;